"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var ButtonGroupItem = {
  styles: function styles(theme) {
    return {
      button: {
        borderRadius: 12,
        borderInlineWidth: 0,
        color: theme.colors.baseContrast070,
        "& svg": {
          fill: theme.colors.baseContrast070 // We should consider revisiting our default color for SvgIcon gloabally
        }
      },
      small: {
        height: theme.spacing.base * 4,
        padding: [0, theme.spacing.base * 1.5]
      },
      medium: {
        height: theme.spacing.base * 5,
        padding: [theme.spacing.base, theme.spacing.base * 2]
      },
      large: {
        height: theme.spacing.base * 6,
        padding: [theme.spacing.base, theme.spacing.base * 3]
      }
    };
  }
};
var _default = exports.default = ButtonGroupItem;